<template>
  <van-popup
    v-model="showPopup"
    round
    position="bottom"
    :style="{ height: '50%' }"
    closeable
  >
    <van-empty description="恭喜您，预约成功！">
      <van-button round type="info" class="bottom-button" @click="clickLink">
        完成
      </van-button>
    </van-empty>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
    }
  },
  methods: {
    clickLink() {
      // this.$router.go(-1)
      this.showPopup = false
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped></style>
